import { Histogram } from '@ant-design/plots';
import {toRGB} from "../../utils/colorUtils";

const AntHistogram = ({data, color, binWidth=5}) => {
    const domainAvg = Math.abs(data.reduce((a, b) => a + b, 0) / data.length);
    const domainStd = Math.sqrt(data.reduce((a, b) => a + Math.pow(b - domainAvg, 2), 0) / data.length);
    const chartData = data.map(x=>{return {value: x}});
    const skewness = data.reduce((a, b) => a + Math.pow((b - domainAvg) / domainStd, 3), 0) / data.length;

    const config = {
        data: chartData,
        style: {
            inset: 0.4,
            stroke: '#fff',
            fill: `linear-gradient(to bottom, ${toRGB(color, 1)}, ${toRGB(color, 0.5)})`,
        },
        binField: 'value',
        channel: 'count',
        binWidth: binWidth,
        scale: {
          x: {
              domainMin: -domainStd*5,
              domainMax: domainStd*5,
              tickCount: 10,
          },
          y: {
            nice: true,
          },
        },
      };

      return <Histogram {...config} />;
    };

export default AntHistogram;